import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CardDialogTitle } from "./CardDialogTitle";
import { Dialog, DialogContent, useTheme, useMediaQuery } from "@mui/material";
import { useCompany } from "../../Shared/components/CompanyProvider/CompanyProvider";
import { BillingInfoText } from "./BillingInformation-types";
import { ResponsiveTable } from "../../Shared/components/ResponsiveTable";
import { buildGiftCardTable } from "./GiftCardTable";
const OldGiftCardsModal = (props) => {
    const { open, oldGiftCards, onClose } = props;
    const { culture } = useCompany();
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    const { columns, rows } = buildGiftCardTable({
        giftCards: oldGiftCards || [],
        culture,
        excludeColumns: ["actions", "balance"],
    });
    return (_jsxs(Dialog, Object.assign({ open: open, onClose: () => onClose(), fullScreen: mobile }, { children: [_jsx(CardDialogTitle, { title: BillingInfoText.OLD_GIFT_CARDS_MODAL_TITLE, onClick: onClose, sx: { marginBottom: theme.spacing(1) } }), _jsx(DialogContent, { children: _jsx(ResponsiveTable, { columns: columns, rows: rows }) })] })));
};
export default OldGiftCardsModal;
